module.exports = __webpack_public_path__ + "img/ico-plus-blue.f71a8a40.svg";